import React, { useState } from 'react';
import { Field, Form } from 'react-final-form';
import { findKnotenById, InputField, required, transformItemsWithIdAndNameForBackend, transformItemsWithIdAndNameForReactSelect } from '../../formHelpers';
import InhaltsElementVerschieben from '../InhaltsElemente/InhaltsElementVerschieben';
import SingleFileUpload from '../Datei/SingleFileUpload';
import TagDropdown from '../Tags/TagDropdown';
import { WysiwygEditor } from '../../WysiwygSSREditor/WysiwygEditor';

export default ({ onSubmit, initialValues = null, toggleModal, alleKnoten, knoten, alleTags }) => {
    const [datei, setDatei] = useState(initialValues ? initialValues.datei : null);
    const [tags, setTags] = useState(initialValues ? transformItemsWithIdAndNameForReactSelect(initialValues.tags) : []);
    const [value, setValue] = useState(initialValues ? initialValues.beschreibung : '');
    return (
        <Form
            onSubmit={values =>
                onSubmit({
                    ...values,
                    beschreibung: value,
                    datei,
                    knoten: initialValues ? findKnotenById(alleKnoten, values.neuerKnoten.value) : knoten,
                    tags: transformItemsWithIdAndNameForBackend(tags),
                })
            }
            initialValues={initialValues}
            render={({ handleSubmit, submitting, invalid }) => (
                <form onSubmit={handleSubmit}>
                    <div className="container-fluid">
                        <div className="row">
                            <InputField label="Bezeichnung">
                                <Field name="bezeichnung" component="input" className="form-control" validate={required} autoFocus>
                                    {props => (
                                        <input
                                            autoFocus
                                            placeholder={props.meta.error && props.meta.touched ? props.meta.error : 'Name'}
                                            {...props.input}
                                            className={`form-control ${props.meta.error && props.meta.touched && 'font-weight-bold border-danger text-danger'}`}
                                        />
                                    )}
                                </Field>
                            </InputField>
                        </div>
                        <div className="row">
                            <InputField label="Tags verwalten" tags={true}>
                                <TagDropdown alleTags={alleTags} tags={tags} setTags={tags => setTags(tags)} />
                            </InputField>
                        </div>
                        <div className="row">
                            {initialValues && <InhaltsElementVerschieben alleKnoten={alleKnoten} aktuellerKnoten={initialValues.knoten} />}
                        </div>
                        <div className="row">
                            <InputField label="Beschreibung">
                                <WysiwygEditor value={value} setValue={setValue} />
                            </InputField>
                        </div>
                        <div className="row">
                            <div className="col-12 d-flex align-items-center">
                                <SingleFileUpload fileRequired={true} initialValues={initialValues} setDatei={datei => setDatei(datei)} />
                            </div>
                        </div>
                    </div>
                    <hr className="w-100" />
                    <div className="modal-footer p-0 w-100 border-0">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={submitting || invalid || datei === null}
                            onClick={e => handleSubmit(e).then(toggleModal())}>
                            Speichern und Schliessen
                        </button>
                    </div>
                </form>
            )}
        />
    );
};
